import { FC } from 'react'
import { Dialog, DialogContent, Button } from '@mui/material'
import { useTranslation } from 'react-i18next'

import Xicon from '../../../../../assets/images/icons/XIcon.svg'
import './user-exists.scss'

type UserExistsModalProps = {
    open: boolean
    closeModal: () => void
    handleSuccessClick: () => void
}

export const UserExistsModal: FC<UserExistsModalProps> = ({
    open,
    closeModal,
    handleSuccessClick,
}) => {
    const { t } = useTranslation()

    return (
        <Dialog
            open={open}
            onClose={closeModal}
            maxWidth={'md'}
            className="user-exists-modal"
        >
            <DialogContent>
                <img
                    className="close"
                    onClick={closeModal}
                    src={Xicon}
                    alt="x"
                />
                <h1 className="title">
                    <span className="title__first-line">
                        {t('common_elements.duplicate_account_error_1')}
                    </span>
                    <span className="title__second-line">
                        {t('common_elements.duplicate_account_error_2')}
                    </span>
                </h1>
                <div className="content">
                    <Button
                        variant="outlined"
                        className="primary-btn-v2 button-req"
                        type="submit"
                        size="small"
                        onClick={closeModal}
                    >
                        {t('common_elements.back_button_text')}
                    </Button>
                    <Button
                        variant="contained"
                        className="secondary-btn button-req"
                        type="submit"
                        size="small"
                        onClick={handleSuccessClick}
                    >
                        {t(
                            'code_verification_page.code_verification_user_account'
                        )}
                    </Button>
                </div>
            </DialogContent>
        </Dialog>
    )
}
